import { server_connection } from 'config';
import moment from 'moment';
import store from 'store';

export const GET_QUIZ_NOT_GRADED_LIST = '[DASHBOARD APP] GET QUIZ NOT GRADED LIST';
export const GET_ASSIGNMENT_NOT_GRADED_LIST = '[DASHBOARD APP] GET ASSIGNMENT NOT GRADED LIST';
export const GET_AGENDA = '[DASHBOARD APP] GET AGENDA';
export const GET_STUDENT_AGENDA = '[DASHBOARD APP] GET STUDENT AGENDA';
export const GET_EVENT_NOT_GRADED_LIST = '[DASHBOARD APP] GET EVENT NOT GRADED LIST';
export const GET_AGENDA_COURSE_LIST = '[DASHBOARD APP] GET AGENDA COURSE LIST';
export const SET_CURRENT_COURSE_ID = '[DASHBOARD APP] SET CURRENT COURSE ID';
export const GET_SELF_PACED_COURSES = '[DASHBOARD APP] GET SELF PACED COURSES';
export const GET_NEW_USER_LIST = '[DASHBOARD APP] GET NEW USER LIST';
export const GET_FAILED_EVENTS = '[DASHBOARD APP] GET FAILED EVENTS';
export const RETAKE_APPROVE = '[DASHBOARD APP] RETAKE APPROVE';

export function getQuizzesNotGraded(instructor_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/quiz_not_graded_list/' + instructor_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_QUIZ_NOT_GRADED_LIST,
                    payload: responseData
                })
            })
    }
}


export function getAssignmentsNotGraded(instructor_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/assignment_not_graded_list/' + instructor_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_ASSIGNMENT_NOT_GRADED_LIST,
                    payload: responseData
                })
            })
    }
}

export function getEventsNotGraded(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/event_not_graded_list/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_EVENT_NOT_GRADED_LIST,
                    payload: responseData
                })
            })
    }
}

export function getAgenda(company_calendar_course_id, start_date, end_date) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/get_agenda',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_calendar_course_id, start_date, end_date })
            })
            .then((response) => response.json())
            .then((responseData) => {
                const role_id = store.getState().auth.user.data.role_info.role_id;

                if (role_id === 4) { // Student
                    dispatch({
                        type: GET_STUDENT_AGENDA,
                        payload: responseData
                    });
                } else {
                    dispatch({
                        type: GET_AGENDA,
                        payload: responseData,
                    });
                }
            });
    }
}

export function getAgendaCourseList(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/get_agenda_course_list/' + auth_id)
            .then((response) => response.json())
            .then((agenda_course_list) => {
                // Set agenda_course_list
                dispatch({
                    type: GET_AGENDA_COURSE_LIST,
                    payload: agenda_course_list,
                });

                // Set current_course_id
                let current_course_id = 0;
                if (agenda_course_list.length > 0) {
                    current_course_id = agenda_course_list[0].company_calendar_course_id;
                }

                if (current_course_id !== 0) {
                    dispatch({
                        type: SET_CURRENT_COURSE_ID,
                        payload: current_course_id,
                    });

                    // Set agenda calendar
                    const current_date = moment(new Date());
                    const start_date = current_date.format("YYYY-MM-DD");
                    const end_date = current_date.add(1, "M").format("YYYY-MM-DD");

                    dispatch(getAgenda(current_course_id, start_date, end_date));
                }

            })
    }
}

export function setCurrentCourseID(current_course_id) {
    return (dispatch) => {
        dispatch({
            type: SET_CURRENT_COURSE_ID,
            payload: current_course_id
        })
    }
}

export function getSelfPacedCourses(student_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/get_self_paced_courses/' + student_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_SELF_PACED_COURSES,
                    payload: responseData
                })
            })
    }
}

export function getNewUsers() {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/get_new_user_list')
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_NEW_USER_LIST,
                    payload: responseData
                })
            })
    }
}

export function getFailedEvents(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/dashboard/widget/get_failed_events/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_FAILED_EVENTS,
                    payload: responseData
                })
            })
    }
}

export function retakeApprove(event) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/event_retake_approve',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event })
            })
            .then((responseData) => {
                dispatch({
                    type: RETAKE_APPROVE,
                    payload: event,
                });
            });
    }
}




// WEBPACK FOOTER //
// src/main/content/dashboard/store/actions/widgets.actions.js